export default "__VITE_ASSET__636119e9__"